// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-field-upload-inline__preview-image[data-v-41fa00b8]{width:196px;height:auto;padding:var(--spacer-4) 0;margin-right:var(--spacer-md);margin-top:var(--spacer-xxs);border:1px solid var(--v-gray-extra-light);color:var(--v-gray-dark);cursor:pointer}.form-field-upload-inline__preview-image--dragged-over[data-v-41fa00b8]{border-color:var(--v-gray-medium)}.form-field-upload-inline__preview-remove[data-v-41fa00b8]{margin-right:var(--spacer-lg)!important}", ""]);
// Exports
module.exports = exports;
